import * as React from "react";
import type { SVGProps } from "react";
const SvgTarget011 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="#000"
      d="M12 5.8a1 1 0 1 0 2 0h-2M14 1a1 1 0 1 0-2 0h2m-2 24a1 1 0 1 0 2 0h-2m2-4.8a1 1 0 1 0-2 0h2m6.2-8.2a1 1 0 1 0 0 2v-2m4.8 2a1 1 0 1 0 0-2v2M1 12a1 1 0 1 0 0 2v-2m4.8 2a1 1 0 1 0 0-2v2m16.8-1h-1a8.6 8.6 0 0 1-8.6 8.6v2c5.854 0 10.6-4.746 10.6-10.6zM13 22.6v-1A8.6 8.6 0 0 1 4.4 13h-2c0 5.854 4.746 10.6 10.6 10.6zM3.4 13h1A8.6 8.6 0 0 1 13 4.4v-2C7.146 2.4 2.4 7.146 2.4 13zM13 3.4v1a8.6 8.6 0 0 1 8.6 8.6h2c0-5.854-4.746-10.6-10.6-10.6zm0 2.4h1V1h-2v4.8zM13 25h1v-4.8h-2V25zm7.2-12v1H25v-2h-4.8zM1 13v1h4.8v-2H1zm15.6 0h-1a2.6 2.6 0 0 1-2.6 2.6v2a4.6 4.6 0 0 0 4.6-4.6zM13 16.6v-1a2.6 2.6 0 0 1-2.6-2.6h-2a4.6 4.6 0 0 0 4.6 4.6zM9.4 13h1a2.6 2.6 0 0 1 2.6-2.6v-2A4.6 4.6 0 0 0 8.4 13zM13 9.4v1a2.6 2.6 0 0 1 2.6 2.6h2A4.6 4.6 0 0 0 13 8.4z"
    />
  </svg>
);
export default SvgTarget011;
